import { render, staticRenderFns } from "./LiteWorkspaceFabricVisualize.vue?vue&type=template&id=0bb16ba6&scoped=true&"
import script from "./LiteWorkspaceFabricVisualize.vue?vue&type=script&lang=js&"
export * from "./LiteWorkspaceFabricVisualize.vue?vue&type=script&lang=js&"
import style0 from "./LiteWorkspaceFabricVisualize.vue?vue&type=style&index=0&id=0bb16ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb16ba6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb16ba6')) {
      api.createRecord('0bb16ba6', component.options)
    } else {
      api.reload('0bb16ba6', component.options)
    }
    module.hot.accept("./LiteWorkspaceFabricVisualize.vue?vue&type=template&id=0bb16ba6&scoped=true&", function () {
      api.rerender('0bb16ba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/Lite/LiteWorkspaceFabricVisualize.vue"
export default component.exports